import React, { useState } from 'react';
import Tab from '@mui/material/Tab';
import {
    Switch,
    Route,
    useRouteMatch,
    NavLink,
    useLocation,
} from 'react-router-dom';

import TabPanel from '../../components/TabPanel';
import SubMenu from '../../components/SubMenu';
import TreeBROfferings from '../../pages/admin/TreeBR/TreeBROfferings';

function a11yProps(index) {
    return {
        id: `vertical-tab-${index}`,
        'aria-controls': `vertical-tabpanel-${index}`,
    };
}

const AdminTreeBRRoutes = (props) => {
    let { path } = useRouteMatch();
    const location = useLocation();

    const getActiveTab = () => {
        switch (location.pathname) {
            case '/admin/treebr':
                return 0;
            default:
                return 0;
        }
    };

    const [value, setValue] = useState(getActiveTab());
    return (
        <div>
            <SubMenu value={value} onChange={(e, v) => setValue(v)}>
                <Tab
                    label="TreeBR"
                    {...a11yProps(0)}
                    to={`${path}`}
                    component={NavLink}
                />
            </SubMenu>
            <TabPanel>
                <Switch>
                    <Route exact path={`${path}`} component={TreeBROfferings} />
                    <Route
                        exact
                        path={`${path}/treebr`}
                        component={TreeBROfferings}
                    />
                </Switch>
            </TabPanel>
        </div>
    );
};

export default AdminTreeBRRoutes;
